export const rollbarConfig = {
  enabled: process.env.REACT_APP_ENV === 'prod',
  accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
  environment: process.env.REACT_APP_ENV,
  codeVersion: process.env.REACT_APP_DEPLOY_VERSION,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REACT_APP_DEPLOY_VERSION as string
      }
    }
  }
};
